import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postMolecularForms } from "../../redux/actions/index";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";

const ConsentDrugAlcoholForm = ({ appData, postMolecularFormsFunc }) => {
  const initialData = {
    client: "Molecular",
    signature: `${appData.firstName} ${appData.lastName}`,
    name: `${appData.firstName} ${appData.lastName}`,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <div>
          <p>
            I <b>{initialData.name}</b>, confirm receipt of the Alcohol and
            Drugs Policy and hereby accept and agree to adhere to the Alcohol
            and Drugs Policy, in relation to my assignment with{" "}
            {initialData.client}.
          </p>
          <p>
            During the course of my assignment with {initialData.client}, I
            agree to submit a breath test, as required, to the Testing
            Contractor for the purpose of testing for alcohol use; and agree to
            submit a urine test, as required, to the Testing Contractor for the
            purpose of testing for drugs.
          </p>
          <p>
            I confirm that I will advise HRGO Recruitment with immediate effect
            if this situation changes.
          </p>
        </div>
      ),
    },

    signature: {
      type: "text",
      title: "Signed",
      value: getVal("signature"),
      disabled: true,
    },
    name: {
      type: "text",
      title: "Print Name",
      value: getVal("name"),
      disabled: true,
    },
    date: {
      type: "text",
      title: "Date",
      value: getVal("date"),
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const submitted =
    appData.molecularOnboarding && appData.molecularOnboarding.YML1;

  const redirectBack = () => {
    history.push("/profile/edit/molecular-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postMolecularFormsFunc("YML1", {
      ...fieldValuesPayload,
      client: initialData.client,
    });
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Consent for Random Drug / Alcohol Testing"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"molecular"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

ConsentDrugAlcoholForm.propTypes = {
  appData: any,
  postMolecularFormsFunc: func,
};

const mapDispatchToProps = {
  postMolecularFormsFunc: postMolecularForms,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(ConsentDrugAlcoholForm);
